class EventEmitter {
  constructor() {
    this._events = new Map();
  }

  on = (evtName, callback) => {
    if (!this._events.has(evtName)) {
      this._events.set(evtName, new Set());
    }
    this._events.get(evtName).add(callback);
  };

  off = (evtName, callback) => {
    if (this._events.has(evtName)) {
      this._events.get(evtName).delete(callback);
      if (this._events.get(evtName).size === 0) {
        this._events.delete(evtName);
      }
    }
  };

  emit(evtName, data) {
    this._events.forEach((subscribers, name) => {
      if (
        name === '*' ||
        (name instanceof RegExp && name.test(evtName)) ||
        name === evtName
      ) {
        subscribers.forEach((callback) => callback(data));
      }
    });
  }

  onAll(callback) {
    this.on('*', callback);
  }

  offAll() {
    this._events = new Map();
  }
}

export default EventEmitter;
